"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GenerateSummaryButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const document_1 = require("../../store/selectors/document");
const useDevice_1 = require("../../hooks/useDevice");
const FloatingButton_1 = require("../FloatingButton");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
const AddSources_1 = __importDefault(require("../AddSources"));
const AppText_1 = require("../AppText");
function GenerateSummaryButton() {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const navigation = (0, native_1.useNavigation)();
    const wasDocumentUploadCompleted = (0, react_redux_1.useSelector)(document_1.selectDocumentUploadComplete);
    const [isGenerationModalOpen, setIsGenerationModalOpen] = (0, react_1.useState)(false);
    const startGeneration = (0, react_1.useCallback)(() => {
        if (isMobileScreen) {
            navigation.navigate('AddSources');
        }
        else {
            setIsGenerationModalOpen(true);
        }
    }, [navigation, isMobileScreen]);
    const closeGenerationModal = (0, react_1.useCallback)(() => {
        setIsGenerationModalOpen(false);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [styles.uploadButtonContainer, { transform: [{ translateY: scrollY }] }], children: isMobileScreen ? ((0, jsx_runtime_1.jsx)(BigButton_1.default, { fullWidth: true, disabled: wasDocumentUploadCompleted !== undefined && !wasDocumentUploadCompleted, containerStyle: styles.buttonItem, onPress: startGeneration, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.buttonContent, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faFileUpload, size: 16, color: 'white' }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.buttonText, children: wasDocumentUploadCompleted !== undefined && !wasDocumentUploadCompleted
                                    ? 'Uploading Document...'
                                    : 'Upload Document' })] }) })) : ((0, jsx_runtime_1.jsx)(FloatingButton_1.FloatingButton, { disabled: wasDocumentUploadCompleted !== undefined && !wasDocumentUploadCompleted, onPress: startGeneration, children: wasDocumentUploadCompleted !== undefined && !wasDocumentUploadCompleted
                        ? 'Uploading Document...'
                        : 'Upload Document' })) }), (0, jsx_runtime_1.jsx)(AddSources_1.default, { isOpen: isGenerationModalOpen, onClose: closeGenerationModal })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    uploadButtonContainer: {
        position: 'absolute',
        bottom: 8,
        left: 0,
        right: 0,
        paddingHorizontal: 20,
    },
    buttonItem: {
        width: '100%',
    },
    buttonContent: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
    },
    buttonText: {
        color: 'white',
        fontSize: 16,
        fontWeight: '500',
    },
});
